exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-wrapper[data-v-064838e1] {\n  margin: 25px 15px 0 5px;\n}\n", ""]);

// exports
